import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { FilterApiService } from '../../../../../services/api/filter-api.service';
import { CampCareFormMode } from '../camp-care.mode';
import { TextMaskService } from '@bayclubs/ui-text-mask';

@Component({
    selector: 'app-camp-care-day-edit',
    templateUrl: './camp-care-day-edit.component.html',
    styleUrls: ['./camp-care-day-edit.component.scss'],
    standalone: false
})
export class CampCareDayEditComponent implements OnInit {
    @Input()
    public form: UntypedFormGroup;

    public isGeneratorVisible: boolean = false;
    public isBusy: boolean = false;
    public ageChange: boolean = false;

    public clubDropdownItems = [];

    constructor(public mask: TextMaskService, private filters: FilterApiService) {}

    ngOnInit(): void {
        this.isBusy = true;

        this.loadFilters();

        this.form.get('ageInMonthsFrom').valueChanges.subscribe(value => {
            this.form.get('ageInMonthsFromEffective').setValue(value);
        });
        this.form.get('ageInMonthsTo').valueChanges.subscribe(value => {
            if (value % 12 == 0) {
                value = value + 12;
            }

            this.form.get('ageInMonthsToEffective').setValue(value);
        });
    }

    public onClubsChanged(data: Array<DropdownMultiselectItem>) {
        let clubCodes = data.map(x => x.id);

        this.form.controls['clubCodes'].setValue(clubCodes);
    }

    public isGenerateMode() {
        return this.form.value.mode == CampCareFormMode.Generate;
    }

    public canEditDate(): boolean {
        return this.form.value.mode != CampCareFormMode.Edit;
    }

    public canEditClub(): boolean {
        return this.form.value.mode != CampCareFormMode.Edit;
    }

    private loadFilters() {
        this.filters.get(false).subscribe(data => {
            if (data.isSuccess) {
                this.clubDropdownItems = data.value.clubs.map(x => this.createDropdownItem(x.code, x.code, false, x.name));
                this.isBusy = false;
            }
        });
    }

    private createDropdownItem(id, value, isSelected: boolean = false, displayValue: string = null): DropdownMultiselectItem {
        return <DropdownMultiselectItem>{
            id: id,
            value: value,
            selected: isSelected,
            displayName: displayValue
        };
    }

    public toggleAgeChange() {
        this.ageChange = !this.ageChange;
    }
}
